import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import DropDown from '../../Input/DropDown'
import { useLanguages } from '../../../hooks'
import { languageLevels } from '../../../constants'

const LanguageSelect = ({ value: languages, onChange, clearErrors, setError }) => {
  const { formattedWorldLanguages } = useLanguages()

  const { getValues, resetField, control } = useForm({
    defaultValues: {
      newLanguage: '',
      newLevel: '',
    },
  })

  const handleAdd = () => {
    const language = getValues('newLanguage')
    const level = getValues('newLevel')

    if (!language || !level) {
      setError('user_profile_languages', {
        type: 'manual',
        message: 'You must select at least one language and level',
      })
      return
    }

    const isDuplicate = languages.some((item) => item.language === language)
    if (isDuplicate) {
      setError('user_profile_languages', {
        type: 'manual',
        message: 'This language has already been added',
      })
      return
    }

    onChange([...languages, { language, level }])

    resetField('newLanguage')
    resetField('newLevel')
  }
  const handleAddAuto = (language, level) => {
    clearErrors('user_profile_languages')
    const isDuplicate = languages.some((item) => item.language === language)
    if (isDuplicate || !language || !level) return

    onChange([...languages, { language, level }])
    resetField('newLanguage')
    resetField('newLevel')
  }

  const handleDelete = (deleteLanguage) => {
    onChange(languages.filter((lang) => lang.language !== deleteLanguage))
  }

  return (
    <div className="flex flex-col mt-2 gap-y-[20px]">
      {/* Render existing languages */}
      {languages.map((item, idx) => (
        <div key={`${item.language}-${idx}`} className="flex flex-wrap gap-[20px]">
          <div className="flex-1">
            <input
              disabled
              readOnly
              value={formattedWorldLanguages.find((lang) => lang.value === item.language)?.label}
              className="w-full h-[44px] !border-[#FFCA84]/30 border bg-white rounded-[8px] shadow-button py-[10px] px-[14px] text-base font-normal leading-[24px] text-primary-100"
            />
          </div>
          <div className="flex-1">
            <input
              disabled
              readOnly
              value={languageLevels.find((level) => level.value === item.level)?.label}
              className="w-full h-[44px] !border-[#FFCA84]/30 border bg-white rounded-[8px] shadow-button py-[10px] px-[14px] text-base font-normal leading-[24px] text-primary-100"
            />
          </div>
          <button
            type="button"
            onClick={() => handleDelete(item.language)}
            className="w-[40px] h-[40px]"
          >
            <img src="/assets/image/delete_button.svg" alt="Delete" className="w-full h-full" />
          </button>
        </div>
      ))}

      {/* New entry dropdowns */}
      <div className="flex flex-wrap gap-[20px]">
        <div className="flex-1">
          <Controller
            control={control}
            name="newLanguage"
            render={({ field: { value, onChange } }) => (
              <DropDown
                placeholder="Select Language"
                menuItems={formattedWorldLanguages}
                value={value}
                setValue={(val) => {
                  console.log(val)
                  onChange(val)
                  if (getValues('newLevel')) {
                    handleAddAuto(val, getValues('newLevel'))
                  }
                }}
                className="!h-[44px]"
              />
            )}
          />
        </div>

        <div className="flex-1">
          <Controller
            control={control}
            name="newLevel"
            render={({ field: { value, onChange } }) => (
              <DropDown
                placeholder="Select Level"
                menuItems={languageLevels}
                value={value}
                setValue={(val) => {
                  onChange(val)
                  if (getValues('newLanguage')) {
                    handleAddAuto(getValues('newLanguage'), val)
                  }
                }}
                className="!h-[44px]"
              />
            )}
          />
        </div>

        <button onClick={handleAdd} type="button" className="w-[40px] h-[40px]">
          <img src="/assets/image/add_button.svg" alt="Add" className="w-full h-full" />
        </button>
      </div>
    </div>
  )
}

export default LanguageSelect
